module.exports = __webpack_public_path__ + "static/media/mhr-icon.047c0fd1.svg";